/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { DotNetFormulaDataModel } from '../models/dot-net-formula-data.model';
import { FormValueModel } from '../models/form-value.model';

@Injectable()
export class DotNetFormulaDataProvider {
	public constructor() {}

	public prepareColumnsData(formValue: FormValueModel): DotNetFormulaDataModel[] {
		if(!formValue.status) {
			formValue.status = 1;
		}

		return(
			Object.entries(formValue)
				/* eslint-disable @typescript-eslint/no-unused-vars */
				.filter(([_, value]: [string, string | boolean | number]) => typeof value !== 'boolean')
				.map(([column, value]: [string, string | number]) => ({
					Name: column,
					Value: value ? value.toString() : ''
				}))
		);
	}
}